import script from "./CustomSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=35eb6b94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35eb6b94"]])

export default __exports__